
<template>

    <div>
        <h3>Connections</h3>
        <line-chart :chart-data="datacollection"></line-chart>
    </div>
</template>




<script>
    import { mapState } from 'vuex'
    import LineChart from './line-chart'

    export default {
        components: {
            LineChart
        },
        data() {
            return {
                datacollection: null,
                engineDataset: { Total: [] },
                dates: [],
                poll: null
            }
        },
        computed: {
            ...mapState({
                servers: state => state.servers
            }),

        },
        created () {
	this.pollServers()
},
        mounted() {
        },
        methods: {
            pollServers() {
                this.polling = setInterval(() => {
                    this.readConnections()
                }, 5000)
            },
            readConnections() {

                let engineServers = this.servers.filter(s => s.type == "Comms Engine")
                var total = 0



                engineServers.forEach(server => {

                    if (server.name in this.engineDataset)
                        this.engineDataset[server.name].push(server.statistics.InitliasedDevices)
                    else
                        this.engineDataset[server.name] = [server.statistics.InitliasedDevices]
                    total += server.statistics.InitliasedDevices

                })

                this.engineDataset['Total'].push(total)
                this.dates.push(new Date())

                let engineDatasetsLocal = []
                var myColors = ['#c45850', '#e8c3b9','#3cba9f', '#8e5ea2','#3e95cd', '#e8c3b9' ]
                var index = 0

                for (var prop in this.engineDataset) 
                    if (Object.prototype.hasOwnProperty.call(this.engineDataset, prop)) 
                        engineDatasetsLocal.push({ label: prop, data: this.engineDataset[prop], fill: false, borderColor: myColors[index++] })


                this.datacollection = {
                    labels: this.dates,
                    datasets: engineDatasetsLocal
                }



                //// append the new data to the existing chart data
                //myChart.data.datasets[0].data.push({
                //    x: event.timestamp,
                //    y: event.value
                //});

                //// update chart datasets keeping the current animation
                //myChart.update({
                //    preservation: true
                //});
            }
        }
    }


</script>

<style>
</style>
